import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FileType } from '../../../core/model/file';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { FileDownloaderService } from '../../../core/services/file-downloader.service';
import { FileManagerService } from '../../../core/services/files/file-manager.service';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';
import { ModalConfirmationComponent } from '../../modal-confirmation/modal-confirmation.component';


@Component({
  selector: 'app-file-element',
  templateUrl: './file-element.component.html',
  styleUrls: ['./file-element.component.css']
})
export class FileElementComponent implements OnInit {
  @ViewChild('fileInput') fileInput;
  @ViewChild('popupShare') popupShare;
  @Input()
  set name(fileName: string) {
    this._fileName = fileName;
    this.extension = fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase();
  }
  get name(): string {
    return this._fileName;
  }
  @Input() guid: string;
  @Input() date: string;
  private _fileData: any;
  @Input()
  set fileData(data: any) {
    this._fileData = data;
  }
  get fileData(): any {
    return this._fileData;
  }
  @Input() new: boolean;
  @Input() overwrite = false;
  @Input() inventariar = false;
  @Input() idContenido = 0;
  @Input() canShare = false;
  @Input() canRemove = false;
  @Input() canUploadFiles = false;
  @Output() fileUploaded = new EventEmitter<string>();

  @Output() fileInventoryUploaded = new EventEmitter<string>();
  @Output() removeElement = new EventEmitter<{ name: string, guid: string, date: string }>();
  @Output() fileReplaced = new EventEmitter<{ newGuid: string, oldGuid: string }>();

  extension: string;
  loading = false;
  private _fileName: string;

  modalRef: BsModalRef;
  linkShared: string;

  constructor(
    private fileManagerService: FileManagerService,
    private modalService: BsModalService,
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private fileService: FileDownloaderService,
    private utilitiesService: UtilitiesService
  ) { }

  ngOnInit() { }

  downloadFile() {
    if (this.fileData) {
      this.utilitiesService.downloadGenericFile(this.name, this.fileData);
    } else if (this.guid) {
      this.loading = true;
      this.fileManagerService.downloadFileFromRepository(this.guid).subscribe(data => {
        this.loading = false;
        this._saveAs(this.name, data);
      },
        error => this.loading = false);
    }
  }

  private _saveAs(fileName: string, data: any) {
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    const blob = new Blob([data], { type: 'application/octet-stream' });
    let objectUrl = '';
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // save file for IE
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // save for other browsers: Chrome, Firefox
      objectUrl = URL.createObjectURL(blob);
      // window.open(objectUrl);
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
    }
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  loadFile() {
    this.loading = true;
    const file = this.fileInput.nativeElement.files[0];
    // addFileAndOCRToRepo
    if (!this.inventariar) {
      this.fileManagerService.uploadFileToRepository(file, true, FileType.CARGA_MASIVA).subscribe(guid => {
        this.loading = false;
        this.fileUploaded.emit(guid);
        this.toastr.clear();
        this.toastr.success('Se ha subido correctamente el fichero al repositorio', 'Fichero subido correctamente');
      },
        error => {
          this.loading = false;
          this.toastr.clear();
          this.toastr.error('Se ha producido un error al subir el fichero al repositorio', 'Error al subir el fichero');
        });
    } else {
      // Si se marca el inventariar, hay que guardarlo a través del OCR para que el disponga automáticamente que accion realizar
      // no habría que realizar la accion posterior de asociarlo con el contenido, ya lo hace este servicio
      this.fileManagerService.addFileAndOCRToRepo(file, this.idContenido, this.authService.getIdiomaUser()).subscribe(guid => {
        this.loading = false;
        this.fileInventoryUploaded.emit(guid);
        this.toastr.clear();
        this.toastr.success('Se ha subido correctamente el fichero al repositorio', 'Fichero subido correctamente');
      },
        error => {
          this.loading = false;
          this.toastr.clear();
          this.toastr.error('Se ha producido un error al subir el fichero al repositorio', 'Error al subir el fichero');
        });
    }
  }

  replaceFile() {

    // Muestra un dialogo de confirmacion
    const modal = this.modalService.show(ModalConfirmationComponent);
    (<ModalConfirmationComponent>modal.content).showConfirmationModal(
      'Carga de fichero',
      'El fichero existente será sustituido. ¿Desea continuar?',
      '',
      'Sí',
      'No',
      true,
      'fa-exclamation-triangle fa-3x',
      'bg-danger'
    );

    (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        // Eliminar ficheros
        if (this.idContenido) {
          this.fileManagerService.removeFileFromRepository(this.guid).subscribe(respuesta => {
            if (respuesta > 0) {
              this.toastr.clear();
              this.toastr.info('Se ha eliminado el fichero antiguo correctamente', 'Fichero eliminado correctamente');

              this.loadFile();
            }
          },
            error => {
              this.toastr.clear();
              this.toastr.error('Se ha producido un error al eliminar el fichero antiguo', 'Error detectado');
            });
        }
      } else {
        this.fileInput.nativeElement.value = '';
      }
    });
  }


  private openSharedLinkModal() {
    this.modalRef = this.modalService.show(this.popupShare);
  }

  share() {
    if (!this.linkShared) {
      this.fileService.getShareToken(this.guid)
        .subscribe((sharedToken: string) => {
          this.linkShared = window.location.origin + '/files/' + sharedToken;
          this.openSharedLinkModal();
        });
    } else {
      this.openSharedLinkModal();
    }
  }

  copyLink() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.linkShared;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  remove() {
    this.removeElement.emit({ name: this.name, guid: this.guid, date: this.date });
    this.loadFile();
  }

}
